<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div slot="no-body" class="tabs-container pt-2 px-6">
		<vue-perfect-scrollbar class="scroll-area--form" :settings="settingsForm">
			<vs-alert
				v-if="optimizersList.length > 1"
				class="mb-2"
				:active.sync="closeInfo"
				closable
				icon-pack="feather"
				close-icon="icon-x"
			>
				<span>{{ $t("FieldsWithTheIndicatedIconsAreCompatible") }}</span>
				<div class="flex items-center justify-around">
					<span class="flex items-center">
						<i class="material-icons mr-1 text-danger font-bold" style="font-size: 16px"> adjust </i
						>{{ "Openroute" }}
					</span>
					<span class="flex items-center">
						<i class="material-icons mr-1 text-warning font-bold" style="font-size: 16px"> cloud_circle </i
						>{{ "Gmpro" }}
					</span>
					<span class="flex items-center">
						<i class="material-icons mr-1 text-success font-bold" style="font-size: 15px">
							assistant_direction </i
						>{{ "Tour Planning" }}
					</span>
				</div>
			</vs-alert>
			<div class="vx-row">
				<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
					<vx-card :cardBorder="true" :noShadow="true" :title="$t('GeneralInformation')">
						<template slot="actions">
							<div class="flex justify-center items-center">
								<vs-checkbox
									color="primary"
									v-model="checkboxPickup"
									class="font-bold"
									:disabled="isDisabledPickup"
									>{{ $t("PICKUP") }}</vs-checkbox
								>
								<vs-checkbox
									color="primary"
									v-model="checkboxDelivery"
									class="font-bold"
									:disabled="isDisabledDelivery"
									>{{ $t("DELIVERY") }}</vs-checkbox
								>
							</div>
						</template>
						<form data-vv-scope="create-visit-point">
							<div class="vx-row">
								<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
									<vs-input
										class="w-full"
										v-model="visitPoint.identification"
										v-validate="'required'"
										name="identification"
										:label="$t('Routing.Table.Identification')"
									/>
									<span
										class="text-danger text-sm"
										v-show="errors.has('create-visit-point.identification')"
										>{{ $t("ResourceModule.BasicInfoForm.ValidMessages.Identification") }}</span
									>
								</div>
								<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
									<small class="flex items-center date-label cursor-pointer">
										{{ $t("IdentificationOfOrigin") }}
										<i
											class="material-icons text-primary ml-1"
											style="font-size: 14px"
											:title="$t('IdentificationOfOriginVisitPointText')"
										>
											info
										</i>
									</small>
									<vs-input
										class="w-full"
										v-model="visitPoint.original_identification"
										name="original_identification"
									/>
								</div>
							</div>
							<div class="vx-row mt-2">
								<div
									class="vx-col w-full"
									:class="{
										'md:w-1/2 sm:w-1/2':
											optimizersList.length > 0 && optimizersList.includes('TOUR_PLANNING'),
									}"
								>
									<small>{{ $t("VisitPoints.Location") }}</small>
									<vx-input-group>
										<vs-input
											name="location"
											type="text"
											class="w-full"
											v-model="latAndLng"
											v-validate="'required'"
											:placeholder="'E.j: 6.182280, -75.598677'"
											:disabled="true"
										/>
										<template slot="append">
											<div class="append-text btn-addon">
												<vs-button
													color="primary"
													icon-pack="feather"
													icon="icon-plus"
													:title="$t('Add') + ' ' + $t('Routing.Map.Coordinates')"
													@click.prevent="openMap()"
												></vs-button>
											</div>
										</template>
									</vx-input-group>
									<span
										class="text-danger text-sm"
										v-show="errors.has('create-visit-point.location')"
										>{{
											$t("Routing.AssignColumns.Text1") + " " + $t("Routing.AssignColumns.Text2")
										}}</span
									>
								</div>
								<div
									v-if="optimizersList.length > 0 && optimizersList.includes('TOUR_PLANNING')"
									class="vx-col md:w-1/2 sm:w-1/2 w-full"
								>
									<small class="flex items-center date-label cursor-pointer">
										{{ $t("Territories.Territory") }}
										<span class="flex items-center ml-2" v-if="optimizersList.length > 1">
											<i
												class="material-icons text-success font-bold"
												:style="{fontSize: '13px'}"
												title="Tour Planning"
											>
												assistant_direction
											</i>
										</span>
									</small>
									<v-select
										v-model="visitPoint.territory_id"
										name="territory"
										:options="getTerritoriesIdsUnicos(vehicleList)"
										:dir="$vs.rtl ? 'rtl' : 'ltr'"
										:placeholder="$t('Select')"
									>
										<template v-slot:no-options="{search, searching}">
											<template v-if="searching">
												{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
											</template>
											<template v-else>
												{{ $t("NoResultsFound") }}
											</template>
										</template>
									</v-select>
								</div>
							</div>
							<div class="vx-row mt-2">
								<div
									class="vx-col w-full sm:w-1/1"
									:class="{
										'md:w-3/5': !(optimizersList.length === 1 && optimizersList[0] === 'GMPRO'),
									}"
								>
									<small class="date-label">{{ $t("Routing.CreateVisitPoint.ServiceTime") }}</small>
									<div class="flex flex-row justify-between">
										<vs-input-number
											v-model="hours"
											class="w-full mr-6"
											:label="$t('RouterSelection.Hours')"
											:min="0"
											:max="24"
											@keypress="validateInputNumber"
										/>
										<vs-input-number
											v-model="minutes"
											class="w-full"
											:label="$t('RouterSelection.Minutes')"
											:min="0"
											:max="59"
											@keypress="validateInputNumberMinutes"
										/>
									</div>
								</div>
								<div
									v-if="!(optimizersList.length === 1 && optimizersList[0] === 'GMPRO')"
									class="vx-col w-full sm:w-1/1 md:w-2/5"
								>
									<small class="flex items-center date-label cursor-pointer">
										{{ $t("Priority") }}
										<span class="flex items-center" v-if="optimizersList.length > 1">
											<i
												class="material-icons ml-1 mr-1 text-danger font-bold"
												:style="{fontSize: '14px'}"
												title="Openroute"
											>
												adjust
											</i>
											<i
												class="material-icons text-success font-bold"
												:style="{fontSize: '13px'}"
												title="Tour Planning"
											>
												assistant_direction
											</i>
										</span>
									</small>
									<vs-input-number
										v-model="visitPoint.priority"
										class="ml-6"
										:min="0"
										:max="100"
										@keypress="validateInputNumberPriority"
									/>
								</div>
							</div>
						</form>
					</vx-card>
					<vx-card class="mt-base" :cardBorder="true" :noShadow="true" :title="$t('AdditionalFields')">
						<template slot="actions">
							<vs-button
								class="ml-2 mr-2 font-bold"
								color="primary"
								type="flat"
								icon-pack="feather"
								icon="icon-plus"
								@click.prevent="showPrompt()"
								>{{ $t("Add") }}
							</vs-button>
						</template>
						<div class="additional-fields-scroll">
							<vs-table :data="propertiesList" noDataText="">
								<template slot="thead">
									<vs-th>{{ $t("Label") }}</vs-th>
									<vs-th>{{ $t("Routing.Table.Type") }}</vs-th>
									<vs-th>{{ $t("Value") }}</vs-th>
									<vs-th>{{ $t("Routing.Table.Actions") }}</vs-th>
								</template>

								<template slot-scope="{data}">
									<vs-tr :key="indextr" v-for="(tr, indextr) in data">
										<vs-td :data="data[indextr].label">{{ data[indextr].label }}</vs-td>
										<vs-td :data="data[indextr].type.value">{{ data[indextr].type.value }}</vs-td>
										<vs-td :data="data[indextr].value">{{ data[indextr].value }}</vs-td>
										<vs-td>
											<feather-icon
												icon="EditIcon"
												svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
												@click="editSelect(data[indextr], indextr)"
											/>
											<feather-icon
												icon="Trash2Icon"
												svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
												@click="deleteItem(data[indextr], indextr)"
											/>
										</vs-td>
									</vs-tr>
								</template>
							</vs-table>
						</div>
						<vs-prompt
							:title="$t('PropertyDefinition')"
							:active.sync="showPromptField"
							:acceptText="$t('Accept')"
							:cancelText="$t('Cancel')"
							:is-valid="validFormAdditionalFields"
							@accept="addProperty(property)"
						>
							<div class="vx-row mt-2">
								<div class="vx-col w-full mt-2">
									<small class="date-label cursor-pointer">
										{{ $t("Label") }}: ({{ $t("LabelHelp") }})
										<i
											class="material-icons ml-1 text-center"
											style="font-size: 13px"
											:title="$t('AcceptsNumbersAndTheDashSign')"
										>
											info
										</i>
									</small>
									<vs-input
										v-model.trim="property.label"
										class="w-full"
										name="label"
										:vs-placeholder="$t('Label')"
										:placeholder="$t('Label')"
										:disabled="isUpdate"
										@keypress="validateKeyAdditionalInfo"
									/>
								</div>
								<div class="vx-col w-full">
									<small class="date-label">{{ $t("ResourceModule.Create.Type") }}</small>
									<v-select
										v-model="property.type"
										name="type"
										:options="type"
										:dir="$vs.rtl ? 'rtl' : 'ltr'"
										:clearable="false"
									>
										<template v-slot:no-options="{search, searching}">
											<template v-if="searching">
												{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
											</template>
											<template v-else>
												{{ $t("NoResultsFound") }}
											</template>
										</template>
									</v-select>
								</div>
								<div class="vx-col w-full mt-2">
									<small class="date-label">{{ $t("Value") }}: ({{ $t("TagValue") }})</small>
									<flat-pickr
										v-if="property.type.value === 'datetime'"
										class="w-full"
										v-model="property.value"
										:placeholder="$t('Select')"
										:config="configdateTimePicker"
									/>
									<vs-input
										v-else
										v-model.trim="property.value"
										class="w-full"
										:type="property.type.value"
										:placeholder="
											property.type.value === 'date' || property.type.value === 'time'
												? ''
												: $t('Value')
										"
										:vs-placeholder="$t('Value')"
									/>
								</div>
							</div>
						</vs-prompt>
					</vx-card>
				</div>
				<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
					<vx-card :cardBorder="true" :noShadow="true" style="height: 100%">
						<vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
							<vs-tab :label="$t('VisitPoints.Demands')">
								<div class="float-right">
									<vs-button
										class="ml-2 mr-2 font-bold"
										color="primary"
										icon-pack="feather"
										icon="icon-plus"
										type="flat"
										size="small"
										@click.prevent="showPromptDemands()"
										><small style="font-size: 13px">{{ $t("Teams.Form.Add") }}</small>
									</vs-button>
								</div>
								<vs-table :data="propertiesListDemand" noDataText="">
									<template slot="thead">
										<vs-th>{{ $t("Routing.Table.Name") }}</vs-th>
										<vs-th>{{ $t("ResourceModule.Create.CapacityValue") }}</vs-th>
										<vs-th>{{ $t("Routing.Table.Actions") }}</vs-th>
									</template>

									<template slot-scope="{data}">
										<vs-tr :key="indextr" v-for="(tr, indextr) in data">
											<vs-td :data="data[indextr].name">{{ data[indextr].name }}</vs-td>
											<vs-td :data="data[indextr].amount">{{ data[indextr].amount }}</vs-td>
											<vs-td>
												<feather-icon
													icon="EditIcon"
													svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
													@click="editSelectDemand(data[indextr], indextr)"
												/>
												<feather-icon
													icon="Trash2Icon"
													svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
													@click="deleteItemDemand(data[indextr], indextr)"
												/>
											</vs-td>
										</vs-tr>
									</template>
								</vs-table>
								<vs-prompt
									:title="$t('PropertyDefinition')"
									:active.sync="showPromptDemand"
									:acceptText="$t('Accept')"
									:cancelText="$t('Cancel')"
									:is-valid="validFormDemand"
									@accept="addPropertyDemand(propertyDemand)"
								>
									<div class="vx-row">
										<div class="vx-col w-full">
											<small class="date-label cursor-pointer">
												{{ $t("Routing.Table.Name") }}
											</small>
											<vs-input
												v-model.trim="propertyDemand.name"
												class="w-full"
												name="name"
												:vs-placeholder="$t('Routing.Table.Name')"
												:placeholder="$t('Routing.Table.Name')"
												:disabled="isUpdateDemand"
											/>
										</div>
										<div class="vx-col w-full mt-2">
											<small class="date-label">{{
												$t("ResourceModule.Create.CapacityValue")
											}}</small>
											<vs-input
												v-model.trim="propertyDemand.amount"
												class="w-full"
												type="text"
												:placeholder="
													$t(
														'ResourceModule.CapacitiesActivities.CapacityValidMessages.EnterAmount'
													)
												"
												:vs-placeholder="
													$t(
														'ResourceModule.CapacitiesActivities.CapacityValidMessages.EnterAmount'
													)
												"
												@keypress="validateAmountNumber"
											/>
										</div>
									</div>
								</vs-prompt>
							</vs-tab>
							<vs-tab :label="$t('Skills.Skills')">
								<div class="float-right">
									<vs-button
										class="ml-2 mr-2 font-bold"
										color="primary"
										icon-pack="feather"
										icon="icon-plus"
										type="flat"
										size="small"
										@click.prevent="showPromptSkills()"
										><small style="font-size: 13px">{{ $t("Teams.Form.Add") }}</small>
									</vs-button>
								</div>
								<vs-table :data="propertiesListSkill" noDataText="">
									<template slot="thead">
										<vs-th>{{ $t("Name") }}</vs-th>
										<vs-th>{{ $t("Routing.Table.Actions") }}</vs-th>
									</template>

									<template slot-scope="{data}">
										<vs-tr :key="indextr" v-for="(tr, indextr) in data">
											<vs-td :data="data[indextr]">{{ data[indextr] }}</vs-td>
											<vs-td>
												<feather-icon
													icon="Trash2Icon"
													svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
													@click="deleteItemSkill(indextr)"
												/>
											</vs-td>
										</vs-tr>
									</template>
								</vs-table>
								<vs-prompt
									:title="$t('PropertyDefinition')"
									:active.sync="showPromptSkill"
									:acceptText="$t('Accept')"
									:cancelText="$t('Cancel')"
									:is-valid="validFormSkill"
									@accept="addPropertySkill(propertySkill)"
								>
									<div class="vx-row">
										<div class="vx-col w-full mt-2">
											<small class="date-label">{{ $t("Name") }}</small>
											<vs-input
												v-model.trim="propertySkill"
												class="w-full"
												type="text"
												:placeholder="$t('Name')"
												:vs-placeholder="$t('CompanyConfValueAddValidMessage')"
											/>
										</div>
									</div>
								</vs-prompt>
							</vs-tab>
							<vs-tab :label="$t('Vehicles.PermittedVehicles')">
								<div class="flex items-center justify-end">
									<vs-button
										class="font-bold"
										color="primary"
										icon-pack="feather"
										icon="icon-plus"
										size="small"
										type="flat"
										@click.prevent="showPromptPermittedVehicles()"
										><small style="font-size: 13px">{{ $t("Teams.Form.Add") }}</small>
									</vs-button>
									<select-vehicle
										v-if="vehicleList.length"
										:addVehicle="addVehicleArray"
										:deleteVehicle="deleteItemPermittedVehicle"
									/>
								</div>
								<vs-table :data="propertiesListPermittedVehicle" noDataText="">
									<template slot="thead">
										<vs-th>{{ $t("Identification") }}</vs-th>
										<vs-th>{{ $t("Routing.Table.Actions") }}</vs-th>
									</template>

									<template slot-scope="{data}">
										<vs-tr :key="indextr" v-for="(tr, indextr) in data">
											<vs-td :data="data[indextr]">{{ tr }}</vs-td>
											<vs-td>
												<feather-icon
													icon="Trash2Icon"
													svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
													@click="deleteItemPermittedVehicle(indextr)"
												/>
											</vs-td>
										</vs-tr>
									</template>
								</vs-table>
								<vs-prompt
									:title="$t('PropertyDefinition')"
									:active.sync="showPromptPermittedVehicle"
									:acceptText="$t('Accept')"
									:cancelText="$t('Cancel')"
									:is-valid="validFormPermittedVehicle"
									@accept="addPropertyPermittedVehicle(propertyPermittedVehicle)"
								>
									<div class="vx-row">
										<div class="vx-col w-full mt-2">
											<small class="date-label">{{ $t("Identification") }}</small>
											<vs-input
												v-model.trim="propertyPermittedVehicle"
												class="w-full"
												type="text"
												:placeholder="$t('Identification')"
												:vs-placeholder="$t('CompanyConfValueAddValidMessage')"
											/>
										</div>
									</div>
								</vs-prompt>
							</vs-tab>
							<vs-tab id="tr-info" :label="$t('TimeWindow.TimeWindows')">
								<div class="float-right">
									<vs-button
										class="ml-2 mr-2 font-bold"
										color="primary"
										icon-pack="feather"
										icon="icon-plus"
										type="flat"
										size="small"
										@click.prevent="showPromptTimeWindows()"
										><small style="font-size: 13px">{{ $t("Teams.Form.Add") }}</small>
									</vs-button>
								</div>
								<vs-table
									ref="tableTimeWindow"
									noDataText=""
									:data="propertiesListTimeWindow"
									:key="renderComponentTimeWindow"
								>
									<template slot="thead">
										<vs-th>{{ $t("CompanyCreate.InitDate") }}</vs-th>
										<vs-th>{{ $t("Routing.Table.InitHour") }}</vs-th>
										<vs-th>{{ $t("CompanyCreate.EndDate") }}</vs-th>
										<vs-th>{{ $t("Routing.Table.EndHour") }}</vs-th>
										<vs-th>{{ $t("Routing.Table.Actions") }}</vs-th>
									</template>
									<template slot-scope="{data}">
										<vs-tr :key="indextr" v-for="(tr, indextr) in data">
											<vs-td :data="data[indextr].init_date_window">{{
												data[indextr].init_date_window
											}}</vs-td>
											<vs-td :data="data[indextr].init_hour_window">{{
												data[indextr].init_hour_window
											}}</vs-td>
											<vs-td :data="data[indextr].end_date_window">{{
												data[indextr].end_date_window
											}}</vs-td>
											<vs-td :data="data[indextr].end_hour_window">{{
												data[indextr].end_hour_window
											}}</vs-td>
											<vs-td>
												<feather-icon
													icon="EditIcon"
													svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
													@click="editSelectTimeWindow(data[indextr], indextr)"
												/>
												<feather-icon
													icon="Trash2Icon"
													svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
													@click="deleteItemTimeWindow(indextr)"
												/>
											</vs-td>
											<template
												v-if="
													optimizersList.length > 0 &&
													optimizersList.includes('GMPRO') &&
													isSoftTimeWindow &&
													tr.hasOwnProperty('soft_time_window')
												"
												slot="expand"
											>
												<form>
													<vx-card :cardBorder="true" :noShadow="true">
														<h5 class="flex items-center">
															{{ $t("TimeWindow.SoftTimeWindow") }}
															<i
																v-if="optimizersList.length > 1"
																class="material-icons ml-1 text-warning cursor-pointer font-bold"
																style="font-size: 14px"
																title="Gmpro"
															>
																cloud_circle
															</i>
														</h5>
														<div class="vx-row">
															<vs-list>
																<div class="flex items-center justify-between">
																	<div>
																		<vs-list-header
																			icon="event_available"
																			:title="$t('DesignConfig.Date')"
																		></vs-list-header>
																		<vs-list-item
																			:title="$t('Initial')"
																			:subtitle="tr.soft_time_window.init_date"
																		>
																			<vs-list-item
																				class="pl-6"
																				:title="$t('End')"
																				:subtitle="tr.soft_time_window.end_date"
																			></vs-list-item>
																		</vs-list-item>
																	</div>
																	<div>
																		<vs-list-header
																			icon="alarm_on"
																			:title="$t('Optimization.Time')"
																		></vs-list-header>
																		<vs-list-item
																			:title="$t('Initial')"
																			:subtitle="tr.soft_time_window.init_hour"
																		>
																			<vs-list-item
																				class="pl-6"
																				:title="$t('End')"
																				:subtitle="tr.soft_time_window.end_hour"
																			></vs-list-item>
																		</vs-list-item>
																	</div>
																</div>
																<vs-list-header
																	icon="attach_money"
																	:title="$t('Penalty')"
																></vs-list-header>
																<vs-list-item
																	:title="$t('ByAnticipation')"
																	:subtitle="
																		tr.soft_time_window.cost_per_hour_before.toString()
																	"
																>
																	<vs-list-item
																		:title="$t('ForTardiness')"
																		:subtitle="
																			tr.soft_time_window.cost_per_hour_after.toString()
																		"
																	></vs-list-item>
																</vs-list-item>
															</vs-list>
														</div>
													</vx-card>
												</form>
											</template>
										</vs-tr>
									</template>
								</vs-table>
								<vs-prompt
									class="prompt-content--medium"
									:title="null"
									:active.sync="showPromptTimeWindow"
									:acceptText="$t('Accept')"
									:cancelText="$t('Cancel')"
									:is-valid="validFormTimeWindow"
									@accept="addPropertyTimeWindow(propertyTimeWindow)"
								>
									<vx-card :title="$t('TimeWindow.TimeWindow')" :cardBorder="true" :noShadow="true">
										<div class="vx-row">
											<vs-alert
												:active="isAlertTimeWindow"
												class="mb-2"
												color="danger"
												icon="new_releases"
											>
												{{ $t("TimeWindow.PleaseCompleteThegeneralTimeWindow") }}
											</vs-alert>
											<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
												<small class="date-label">{{ $t("CompanyCreate.InitDate") }}</small>
												<datepicker
													v-model="propertyTimeWindow.init_date_window"
													name="initDate"
													v-validate="'validatorInitDate'"
													:language="$vs.rtl ? langHe : langEn"
													:disabledDates="disabledDatesTo"
													:placeholder="$t('Select')"
												></datepicker>
												<span class="text-danger text-sm" v-show="errors.has('initDate')">{{
													$t("BreakForm.ErrorMessages.DateInitError")
												}}</span>
											</div>
											<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
												<small class="date-label">{{ $t("CompanyCreate.EndDate") }}</small>
												<datepicker
													v-model="propertyTimeWindow.end_date_window"
													name="endDate"
													v-validate="'validatorEndDate'"
													:language="$vs.rtl ? langHe : langEn"
													:disabledDates="disabledDatesTo"
													:placeholder="$t('Select')"
												></datepicker>
												<span class="text-danger text-sm" v-show="errors.has('endDate')">{{
													$t("BreakForm.ErrorMessages.DateInitError")
												}}</span>
											</div>
											<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
												<small class="date-label">{{ $t("Routing.Table.InitHour") }}</small>
												<flat-pickr
													class="w-full"
													v-model="propertyTimeWindow.init_hour_window"
													name="dataHourInit"
													v-validate="'validatorInitHour'"
													:config="configdateTimePicker"
													:placeholder="$t('Select')"
												/>
												<span class="text-danger text-sm" v-show="errors.has('dataHourInit')">{{
													$t("BreakForm.ErrorMessages.ValidInitHour")
												}}</span>
											</div>
											<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
												<small class="date-label">{{ $t("Routing.Table.EndHour") }}</small>
												<flat-pickr
													v-model="propertyTimeWindow.end_hour_window"
													class="w-full"
													v-validate="'validatorEndHour'"
													name="dataHourEnd"
													:placeholder="$t('Select')"
													:config="configdateTimePicker"
												/>
												<span class="text-danger text-sm" v-show="errors.has('dataHourEnd')">{{
													$t("BreakForm.ErrorMessages.ValidEndHour")
												}}</span>
											</div>
										</div>
										<div
											v-if="optimizersList.length > 0 && optimizersList.includes('GMPRO')"
											class="vx-row"
										>
											<div class="vx-col w-full">
												<vx-card
													v-if="
														((isUpdateTimeWindow && propertiesListTimeWindow.length <= 1) ||
															propertiesListTimeWindow.length <= 0) &&
														isSoftTimeWindow
													"
													class="mt-2"
													:title="$t('TimeWindow.SoftTimeWindow')"
													:cardBorder="true"
													:noShadow="true"
												>
													<template slot="actions">
														<i
															v-if="optimizersList.length > 1"
															class="material-icons ml-1 text-warning cursor-pointer font-bold"
															style="font-size: 14px"
															title="Gmpro"
														>
															cloud_circle
														</i>
														<feather-icon
															icon="Trash2Icon"
															svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
															:title="
																$t('Crud.Delete') +
																' ' +
																$t('TimeWindow.SoftTimeWindow')
															"
															@click.prevent="deleteSoftWindow"
														/>
													</template>
													<form>
														<div class="vx-row">
															<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
																<small class="date-label">{{
																	$t("CompanyCreate.InitDate")
																}}</small>
																<datepicker
																	v-model="
																		propertyTimeWindow.soft_time_window.init_date
																	"
																	name="initDateSoftWindow"
																	:language="$vs.rtl ? langHe : langEn"
																	:placeholder="$t('Select')"
																></datepicker>
																<span
																	class="text-danger text-sm"
																	v-if="
																		isStartBeforeEnd(
																			propertyTimeWindow,
																			'init_date',
																			'end_date'
																		)
																	"
																	>{{
																		$t("BreakForm.ErrorMessages.DateInitError")
																	}}</span
																>
																<span
																	class="text-danger text-sm"
																	v-else-if="
																		showErrorSoftWindow(
																			propertyTimeWindow,
																			'init_date_window',
																			'init_date'
																		)
																	"
																	>{{ $t("TheStartDateMust") }}</span
																>
															</div>
															<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
																<small class="date-label">{{
																	$t("CompanyCreate.EndDate")
																}}</small>
																<datepicker
																	v-model="
																		propertyTimeWindow.soft_time_window.end_date
																	"
																	name="endDateSoftWindow"
																	:language="$vs.rtl ? langHe : langEn"
																	:placeholder="$t('Select')"
																></datepicker>
																<span
																	class="text-danger text-sm"
																	v-show="
																		showErrorSoftWindow(
																			propertyTimeWindow,
																			'end_date_window',
																			'end_date'
																		)
																	"
																	>{{ $t("TheEndDateMust") }}</span
																>
															</div>
															<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
																<small class="date-label">{{
																	$t("Routing.Table.InitHour")
																}}</small>
																<flat-pickr
																	class="w-full"
																	v-model="
																		propertyTimeWindow.soft_time_window.init_hour
																	"
																	name="dataHourInitSoftWindow"
																	:config="configdateTimePicker"
																	:placeholder="$t('Select')"
																/>
																<span
																	class="text-danger text-sm"
																	v-if="
																		isStartBeforeEnd(
																			propertyTimeWindow,
																			'init_hour',
																			'end_hour'
																		)
																	"
																	>{{
																		$t("BreakForm.ErrorMessages.ValidInitHour")
																	}}</span
																>
																<span
																	class="text-danger text-sm"
																	v-else-if="
																		showErrorSoftWindowHour(
																			propertyTimeWindow,
																			'init_hour_window',
																			'init_hour'
																		)
																	"
																	>{{ $t("TheStartTimeMust") }}</span
																>
															</div>
															<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
																<small class="date-label">{{
																	$t("Routing.Table.EndHour")
																}}</small>
																<flat-pickr
																	v-model="
																		propertyTimeWindow.soft_time_window.end_hour
																	"
																	class="w-full"
																	name="dataHourEndSoftWindow"
																	:placeholder="$t('Select')"
																	:config="configdateTimePicker"
																/>
																<span
																	class="text-danger text-sm"
																	v-show="
																		showErrorSoftWindowHour(
																			propertyTimeWindow,
																			'end_hour_window',
																			'end_hour'
																		)
																	"
																	>{{ $t("TheEndTimeMust") }}</span
																>
															</div>
														</div>
														<div class="vx-row">
															<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
																<small class="date-label">{{
																	$t("TimeWindow.PenaltyForAnticipation")
																}}</small>
																<vs-input
																	class="w-full"
																	v-model="
																		propertyTimeWindow.soft_time_window
																			.cost_per_hour_before
																	"
																	name="penaltyForAnticipation"
																	@blur="validatePerCost()"
																	@keypress="validateAmountNumber"
																/>
															</div>
															<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
																<small class="date-label">{{
																	$t("TimeWindow.PenaltyForLateness")
																}}</small>
																<vs-input
																	class="w-full"
																	v-model="
																		propertyTimeWindow.soft_time_window
																			.cost_per_hour_after
																	"
																	name="penaltyForLateness"
																	@blur="validatePerCost()"
																	@keypress="validateAmountNumber"
																/>
															</div>
														</div>
													</form>
												</vx-card>
												<div
													v-else-if="
														((isUpdateTimeWindow && propertiesListTimeWindow.length <= 1) ||
															propertiesListTimeWindow.length <= 0) &&
														!isSoftTimeWindow
													"
													class="flex items-center justify-between p-2 mt-2"
													style="border: 1px solid #ccc; border-radius: 5px"
												>
													<h5 class="flex items-center">
														{{ $t("TimeWindow.SoftTimeWindow") }}
														<i
															v-if="optimizersList.length > 1"
															class="material-icons ml-1 text-warning cursor-pointer font-bold"
															style="font-size: 14px"
															title="Gmpro"
														>
															cloud_circle
														</i>
													</h5>
													<vs-button
														class="font-bold"
														icon-pack="feather"
														icon="icon-plus"
														type="flat"
														size="small"
														@click.prevent="AddSofTimeWindow()"
														><small style="font-size: 13px">{{
															$t("Teams.Form.Add")
														}}</small>
													</vs-button>
												</div>
												<vs-alert v-else active class="mt-2" color="primary">
													<span>
														{{ $t("TimeWindow.RemoveAllOtherTimeWindowsToEnable") }}
													</span>
												</vs-alert>
											</div>
										</div>
									</vx-card>
								</vs-prompt>
							</vs-tab>
						</vs-tabs>
					</vx-card>
				</div>
			</div>
		</vue-perfect-scrollbar>
		<div class="vx-row mt-4 sidebar-actions-footer">
			<div class="vx-col w-full">
				<div class="flex flex-wrap items-center justify-end">
					<vs-button class="ml-auto" color="danger" @click.stop="closeSidebarAddVisitPoint()">{{
						$t("Cancel")
					}}</vs-button>
					<vs-button class="ml-4" :disabled="!validateForm" @click.prevent="addVisitPoint()">{{
						$t("Add")
					}}</vs-button>
				</div>
			</div>
		</div>
		<!-- MAP COMPONENT -->
		<vs-popup
			class="vs-popup--content-custom"
			:fullscreen="formatData.cx === 0 && formatData.cy === 0 ? false : true"
			:title="vsPopupTitle"
			:active.sync="popupMapMounted"
		>
			<div class="vx-row">
				<div :class="formatData.cx === 0 && formatData.cy === 0 ? 'vx-col w-full' : 'vx-col w-full md:w-1/2'">
					<vx-card no-shadow card-border>
						<vs-alert color="success" vs-icon="new_releases" class="mb-2" :active.sync="geoAlert">
							{{ $t("Routing.FromMapTitle") }}
						</vs-alert>
						<popup-map
							v-if="popupMapMounted"
							:name="mapConfig.name"
							:latitude="mapConfig.latitude"
							:longitude="mapConfig.longitude"
							:zoom="mapConfig.zoom"
							:theme="mapConfig.theme"
							:calledFrom="mapConfig.calledFrom"
							:changeCursorEnable="true"
							:getCallbackClick="callbackClick"
							:getCoordinatesDrag="getCoordinatesDrag"
							@getInstanceMap="getInstanceMap"
						></popup-map>
					</vx-card>
				</div>
				<div v-if="formatData.cx !== 0 && formatData.cy !== 0" class="vx-col w-full md:w-1/2">
					<vx-card no-shadow card-border>
						<form class="form-content">
							<vs-alert
								color="success"
								closable
								icon-pack="feather"
								close-icon="icon-x"
								:active.sync="geoAlertAddress"
							>
								{{
									$t("Routing.Map.GeoreferencingByAddress") +
									" " +
									$t("AssignedTeams.ClickOnButton").toLocaleLowerCase() +
									" " +
									$t("Routing.Map.Georeference").toLocaleLowerCase()
								}}
								<feather-icon svgClasses="h-4 w-4" icon="GlobeIcon" />
								{{
									$t("Routing.Map.DiscardTheChanges").toLocaleLowerCase() +
									" " +
									$t("AssignedTeams.ClickOnButton").toLocaleLowerCase() +
									" " +
									$t("Cancel").toLocaleLowerCase()
								}}
								<feather-icon svgClasses="h-4 w-4" icon="XIcon" />
							</vs-alert>
							<div class="vx-row">
								<div class="vx-col w-full">
									<div class="vx-row mb-4">
										<div class="vx-col w-full">
											<label class="vs-input--label">{{ $t("Address") }}</label>
											<vx-input-group>
												<vs-input
													v-model="formatData.address"
													name="item-address"
													v-validate="'required'"
													:disabled="isDisabled"
													@change="(showGeoAgain = true), (isDisabled = false)"
												/>
												<template slot="append">
													<div class="append-text btn-addon">
														<vs-button
															v-if="!isDisabled"
															color="warning"
															icon-pack="feather"
															icon="icon-x"
															:title="$t('Cancel')"
															@click.prevent="cancelAction"
														></vs-button>
														<vs-button
															v-if="!isDisabled"
															color="primary"
															icon-pack="feather"
															icon="icon-globe"
															:title="$t('Routing.Map.GeoCoordinates')"
															@click.prevent="geoCoder"
														></vs-button>
														<vs-button
															v-else
															:title="$t('Edit') + ' ' + $t('Address')"
															icon-pack="feather"
															icon="icon-edit"
															@click.prevent="
																(isDisabled = !isDisabled),
																	(geoAlertAddress = true),
																	(showButtonAddCoordinates = false)
															"
														/>
													</div>
												</template>
											</vx-input-group>
											<span class="text-danger text-sm" v-show="errors.has('item-address')">{{
												$t("CompanyModule.Form.ValidMessages.Address")
											}}</span>
										</div>
									</div>
									<div class="vx-row mb-4">
										<div class="vx-col w-full">
											<label class="vs-input--label">{{ $t("Country") }}</label>
											<v-select
												v-model="selectedCountry"
												v-validate="'required'"
												name="country"
												:clearable="false"
												:disabled="
													formatData.address === '' ||
													formatData.address === null ||
													formatData.address === undefined
												"
												:options="countriesOptions"
												:dir="$vs.rtl ? 'rtl' : 'ltr'"
											>
												<template v-slot:no-options="{search, searching}">
													<template v-if="searching">
														{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
													</template>
													<template v-else>
														{{ $t("NoResultsFound") }}
													</template>
												</template>
											</v-select>
											<span class="text-danger text-sm" v-show="errors.has('country')"
												>{{ $t("ResourceModule.BasicInfoForm.ValidMessages.Country") }}
											</span>
										</div>
									</div>
									<div class="vx-row mb-4">
										<div class="vx-col w-full">
											<label class="vs-input--label">{{ getPoliticalDivision.department }}</label>
											<v-select
												v-model="selectedDepartment"
												name="departments"
												:loading="departments.length <= 0 && selectedCountry ? true : false"
												:clearable="false"
												:disabled="
													departments.length <= 0 ||
													formatData.address === '' ||
													formatData.address === null ||
													formatData.address === undefined ||
													isDisabled
												"
												:options="departments"
												:dir="$vs.rtl ? 'rtl' : 'ltr'"
											>
												<template v-slot:no-options="{search, searching}">
													<template v-if="searching">
														{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
													</template>
													<template v-else>
														{{ $t("NoResultsFound") }}
													</template>
												</template>
											</v-select>
											<span class="text-danger text-sm" v-show="errors.has('departments')"
												>{{
													$t("ValidateField", {
														n: getPoliticalDivision.department.toLowerCase(),
													})
												}}
											</span>
										</div>
									</div>
									<div class="vx-row mb-4">
										<div class="vx-col w-full">
											<label class="vs-input--label">{{ getPoliticalDivision.city }}</label>
											<v-select
												v-model="dataCity"
												v-validate="'required'"
												name="cities"
												:loading="
													cities.length <= 0 && selectedDepartment && selectedCountry
														? true
														: false
												"
												:clearable="false"
												:disabled="
													cities.length <= 0 ||
													formatData.address === '' ||
													formatData.address === null ||
													formatData.address === undefined ||
													isDisabled
												"
												:options="cities"
												:dir="$vs.rtl ? 'rtl' : 'ltr'"
											>
												<template v-slot:no-options="{search, searching}">
													<template v-if="searching">
														{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
													</template>
													<template v-else>
														{{ $t("NoResultsFound") }}
													</template>
												</template>
											</v-select>
											<span class="text-danger text-sm" v-show="errors.has('cities')"
												>{{ $t("ValidateField", {n: getPoliticalDivision.city.toLowerCase()}) }}
											</span>
										</div>
									</div>
									<div class="vx-row mb-4">
										<div class="vx-col md:w-1/2 w-full">
											<vs-input
												class="w-full"
												:label="$t('Routing.Map.Latitude')"
												v-model="formatData.cy"
												name="cy"
												disabled
											/>
											<span class="text-danger text-sm" v-show="errors.has('cy')">{{
												errors.first("cy")
											}}</span>
										</div>
										<div class="vx-col md:w-1/2 w-full">
											<vs-input
												class="w-full"
												:label="$t('Routing.Map.Longitude')"
												v-model="formatData.cx"
												name="cx"
												disabled
											/>
											<span class="text-danger text-sm" v-show="errors.has('cx')">{{
												errors.first("cx")
											}}</span>
										</div>
									</div>
								</div>
							</div>
						</form>
					</vx-card>
				</div>
			</div>
			<div v-if="formatData.cx !== 0 && formatData.cy !== 0 && showButtonAddCoordinates" class="vx-row">
				<div class="vx-col w-full mt-2">
					<div class="flex flex-wrap items-center justify-end">
						<vs-button
							color="success"
							:disabled="formatData.cx === 0 || formatData.cy === 0"
							@click="confirmCoordinates(formatData)"
							>{{ $t("Add") + " " + $t("Routing.Map.Coordinates") }}
						</vs-button>
					</div>
				</div>
			</div>
		</vs-popup>
	</div>
</template>

<script>
import {visitPointCreateMixin} from "../model/VisitPointCreateMixin.js";

export default {
	mixins: [visitPointCreateMixin],
};
</script>
<style lang="scss" scoped>
.scroll-area--form {
	margin: auto;
	width: 100%;
	min-height: 300px;
	max-height: calc(100vh - 200px);
	overflow-y: auto;
}
.additional-fields-scroll {
	max-height: 300px;
	overflow-y: auto;
	border: 1px solid #eee;
	border-radius: 5px;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
	padding: 10px !important;
}
.sidebar-actions-footer {
	position: sticky;
	bottom: 0;
	left: 0;
	width: 100%;
	background: #fff;
	z-index: 10;
	padding: 16px 24px;
	display: flex;
	justify-content: flex-end;
	gap: 16px;
	border-top: 1px solid #eee;
}

/* Responsive adjustments */
@media (max-height: 600px) {
	.scroll-area--form {
		max-height: calc(100vh - 150px);
		min-height: 200px;
	}
	.additional-fields-scroll {
		max-height: 200px;
	}
}

@media (max-width: 768px) {
	.scroll-area--form {
		max-height: calc(100vh - 180px);
	}
	.additional-fields-scroll {
		max-height: 250px;
	}
}
</style>
